import Vue from 'vue'
import Router from 'vue-router'
import Com from '@/components/Com'
import About from '@/content/About_us'
import News from '@/content/Our_news'
import Organ from '@/content/Our_organ'
import Case from '@/content/Our_case'
import Honor from '@/content/Our_honor'
import Content from '@/content/Our_content'
import History from '@/content/Our_history'
import Cooper from '@/content/Our_cooper'
import Recruit from '@/content/Our_recruit'
import Contarct from '@/content/Our_contact'
import Dep from '@/content/Our_dep'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [{
      path: '/',
      name: 'com',
      component: Com
    }, {
      path: '/about',
      name: 'about',
      component: About
    }, {
      path: '/news',
      name: 'news',
      component: News
    }, {
      path: '/content',
      name: 'content',
      component: Content
    }, {
      path: '/organ',
      name: 'organ',
      component: Organ
    }, {
      path: '/case',
      name: 'case',
      component: Case
    }, {
      path: '/honor',
      name: 'honor',
      component: Honor
    }, {
        path: '/history',
        name: 'history',
        component: History
      }, {
        path: '/cooper',
        name: 'cooper',
        component: Cooper
      }, {
        path: '/recruit',
        name: 'recruit',
        component: Recruit
      },{
        path:'/contact',
        name:'contact',
        component:Contarct
      },{
        path:'/dep',
        name:'dep',
        component:Dep
      }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js